module.exports = __webpack_public_path__ + "static/media/24_A.6ad08392.png";